import { createAction } from "redux-starter-kit";

import * as TYPES from "../types";

const clearFiles = payload => (dispatch, getState) => {
  dispatch(createAction(TYPES.CLEAR_FILES)({ files: [] }));
};

export default clearFiles;
